import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";
import RecordPager from "MODULES/shared/components/RecordPager";
import { shortDate } from "LIB/formatters/date";
import { CODE, CREATED_AT } from "APP_ROOT/constants";
import { dollars } from "LIB/formatters/currency";
import Actions from "MODULES/IncomingQuotes/Detail/Header/Actions";

export default function Header({ incomingQuote }) {
  return (
    <div className="page-header page-header-bar">
      <h1>
        <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
          <Actions />
        </div>
        <div className="with-padding">
          <RecordPager baseUrl="/incoming-quotes" record={incomingQuote} />
          <span className="header-content">{incomingQuote.get(CODE)}</span>
          <span className="small text-muted">
            Created {shortDate(incomingQuote.get(CREATED_AT))}
          </span>
          <div className="pull-right">
            Total: {dollars(incomingQuote.get("total"))}
          </div>
        </div>
      </h1>
    </div>
  );
}

Header.propTypes = {
  incomingQuote: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/Header/Header.jsx